import Index from './index'
import MicroSite from './microsite'
import Campaign from './campaign'

const basePath = '/recruiting/crm'
export default {
  name: 'crmPageIndex',
  path: `${basePath}`,
  component: Index,
  meta: {
    title: '',
    noAuth: true
  },
  children: [
    {
      name: 'crmMicroSite',
      path: `${basePath}/microsite/:siteId/:pagePath*`,
      component: MicroSite
    },
    {
      name: 'crmCampaign',
      path: `${basePath}/campaign/:siteId/:pagePath*`,
      component: Campaign
    }
  ]
}
